export default __webpack_public_path__ + "static/media/down-arrow.d77e6183.svg";